import Agenda from "../../../Components/Agenda";

export default function AgendaAssistenciaTecnica() {
    return (
        <div className="p-3">
            <div className="card card-custom p-10">
                <Agenda mostrarFiltro />
            </div>
        </div>
    );
}
